class VideoCard extends HTMLElement {
  constructor() {
    super();
    this.video = this.querySelector('video');
    if (!this.video) return;

    this.poster = this.querySelector('.js-video-card__poster');
    this.playButton = this.querySelector('[data-play-video-trigger]');
  }

  connectedCallback() {
    this.bindEvents();
  }

  bindEvents = () => {
    this.addEventListener('mouseenter', this.handleMouseEnter);
    this.addEventListener('mouseleave', this.handleMouseLeave);
    this.playButton.addEventListener('click', this.handlePlayButton);
  };

  handlePlayButton = () => {
    this.removeEventListener('mouseenter', this.handleMouseEnter);
    this.removeEventListener('mouseleave', this.handleMouseLeave);

    if (this.dataset.isPlay === 'false') {
      this.playVideo();
      this.video.muted = false;
      this.setAttribute('data-is-play', 'true');
    } else {
      this.video.pause()
      this.setAttribute('data-is-play', 'false');
    }
  };

  playVideo = () => {
    this.video.play();
    if (this.poster) {
      this.poster.style.display = 'none';
    }
  };

  handleMouseEnter = () => {
    this.playVideo();
  };

  handleMouseLeave = () => {
    this.video.pause();
  };
}

if (customElements && !customElements.get('video-card')) {
  customElements.define('video-card', VideoCard);
}